const trans = {
  "SMS Campaigns": "دعايات ال SMS",
  Campaigns: "الحملات",
  "New Campaign": "حملة جديدة",
  Reach: "عدد العملاء",
  "Campaign name": "اسم الحملة",
  "Campaign purpose": "هدف الحملة",
  "Targeted segment": "الفئة المستهدفة",
  "SMS content": "نص رسالة ال SMS",
  "The maximum number of characters per message in English is X, including spaces and the domain.":
    "الحد الاقصى من الاحرف/الارقام في الرسالة الواحدة باللغة الإنجليزية هو X يشمل عدد احرف الدومين والمسافات",
  "The maximum number of characters per message in Arabic is X, including spaces and the domain.":
    "الحد الاقصى من الاحرف/الارقام في الرسالة الواحدة باللغة العربية هو X يشمل عدد احرف الدومين والمسافات",
  "If there is an emoji character, the limit will be X characters, regardless of language.":
    "إذا كان هناك رمز تعبيري (إيموجي)، فسيكون الحد الأقصى X حرفًا، بغض النظر عن اللغة",
  "Ex: Checkout our offer on new products":
    "مثال: استمتع بالعروض على المنتجات الجديدة",
  "Create Campaign": "انشاء الحملة",
  "All customers": "جميع العملاء",
  Customize: "تخصيص",
  "Campaign cost": "تكلفة الحملة",
  "Current balance": "الرصيد الحالي",
  pointss: "نقاط",
  "Once you create this campaign, a SMS message will be sent to *** customers. Proceed?":
    "عند انشائك لهذه الحملة، سيتم ارسال رسالة نصية الى *** عميل. استمرار؟",
  "* Note:": "* ملاحظة:",
  '"From:': '"من :',
  "will be appended to the end of the message": "ستضاف الى نهاية نص الرسالة",
  "Increase retention rate": "زيادة الولاء",
  "Increase average order value": "زيادة متوسط ​​قيمة الطلب",
  "Increase engagement": "زيادة التفاعل",
  "Increase sales": "زيادة المبيعات",
  "Your store domain will be appended to the end of the message":
    "سيتم اضافة رابط متجرك الى نهاية الرسالة النصية",
  "Campaign Details": "تفاصيل الحملة",
  "Reach numbers": "أرقام العملاء",
};

export default trans;
